import { type AnyAction, type Dispatch, type Middleware, type MiddlewareAPI } from 'redux';
import { get } from 'lodash';
import { SEND_REQUEST, SEND_REQUEST_FAIL } from '../actions/actionTypes/request';
import { getRequestId } from '../../api/requests/requestHelper';
import { showSnackbar } from '../actions/ui';
import { snackbarMessageKeys, snackbarTypes } from '../../components/common/Snackbar/config';
import { INTERNAL_SERVER_ERROR } from '../../api/requests/requestStatusConstants';
import { type RootState } from '../types';

export const request: Middleware =
    (store: MiddlewareAPI<Dispatch<AnyAction>, RootState>) => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        const { type, request: req = {}, meta } = action;

        if (type === SEND_REQUEST) {
            Object.assign(req, {
                requestId: getRequestId(req.type, req.params)
            });
        } else if (type === SEND_REQUEST_FAIL && get(meta, 'error.status') >= INTERNAL_SERVER_ERROR) {
            next(showSnackbar(snackbarMessageKeys.requestFail, snackbarTypes.error));
        }

        return next(action);
    };
